"use client";

import * as stylex from "@stylexjs/stylex";
import prettyMilliseconds from "pretty-ms";
import "@/colors.stylex";
import { colors } from "@/colors.stylex";
import { useMokaMatchContext } from "@/components/moka-match/moka-match-root";
import { Spinner } from "@/components/ui/spinner";
const MokaMatchStatus = () => {
  const {
    errorMessage,
    estimatedRank,
    isEngineReady,
    isMokaThinking,
    position
  } = useMokaMatchContext();
  const isSettled = !isMokaThinking && !errorMessage;
  return <p aria-live="polite" className="x78zum5 x1in32aq xeuugli x1iyjqo2 xs83m0k x1t1x2f9 x6s0dn4 x1d3i0y6 xmotr4s xkpwil5 x8r4c90 xo1l8bm xncyony">
      {(!isEngineReady || isMokaThinking) && !errorMessage && <Spinner />}
      {errorMessage ?? position.gameMessage}
      {position.mokaResponseDurationMs !== null && isSettled && <span className="xss6m8b x1kmivet">
          {prettyMilliseconds(position.mokaResponseDurationMs)}
        </span>}
      {estimatedRank && isSettled && <span title="Estimated from how Moka ranks your moves" className="x8x9d4c xuxw1ft xss6m8b x1kmivet">
          ~{estimatedRank}
        </span>}
    </p>;
};
MokaMatchStatus.displayName = "MokaMatchStatus";
export { MokaMatchStatus };